import { Table, TableBody, TableCell, TableContainer, TableRow, Paper, Card } from "@mui/material";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import ByzGrdDeleteButton from "src/components/core-components/mui/buttons-grid/ByzGrdDeleteButton";
import ByzGrdEditButton from "src/components/core-components/mui/buttons-grid/ByzGrdEditButton";

export default function GridButtons() {
  return (
    <Card sx={{ mb: 3 }}>
      <ByzMuiTypography variant="h3" sx={{borderBottom: "1px solid #E0E0E0"}}>Grid Butonları</ByzMuiTypography>
      <TableContainer sx={{ maxWidth: "50%",}}>
        <Table aria-label="simple table" size="small" stickyHeader>
          <TableBody>
            <TableRow>
              <TableCell>
                <ByzGrdDeleteButton onClick={() => alert("Add Button Clicked")} />
              </TableCell>
              <TableCell>
                <ByzMuiTypography variant="h6">ByzGrdDeleteButton</ByzMuiTypography>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>
                <ByzGrdEditButton onClick={() => alert("Delete Button Clicked")} />
              </TableCell>
              <TableCell>
                <ByzMuiTypography variant="h6">ByzGrdEditButton</ByzMuiTypography>
              </TableCell>
            </TableRow>

          </TableBody>
        </Table>
      </TableContainer>
    </Card>
  );
};